import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { getAllTrackerNumbers } from "sources/admin";

const config = {
    trackerId: {
        // field
        label: "Трекер",
        inputProps: { name: "trackerId" },
        validators: [requiredField],
        propName: "deviceNumber",
        url: getAllTrackerNumbers,
        required: true,
    },
    from: {
        // field
        label: "Начало",
        inputProps: { name: "from", type: "datetime" },
        validators: [requiredField],
        required: true,
    },
    to: {
        // field
        label: "Конец",
        inputProps: { name: "to", type: "datetime" },
        validators: [requiredField],
        required: true,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
